import { useCallback } from 'react';

export function useTaskCompletedToast() {
  return useCallback(() => {
    const toast = document.createElement('div');
    toast.className =
      'fixed bottom-6 left-1/2 -translate-x-1/2 z-tooltip bg-feedback-success text-white px-5 py-3 rounded-lg shadow-lg font-medium text-sm transition-opacity duration-300';
    toast.textContent = 'Task completed — Good job!';
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 1500);
  }, []);
}
